import * as actionTypes from "../../Action/actionTypes";

const initialState = {
  Event_Organizer_Table_data: {
    columns: [
      {
        label: 'Full Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'User Name',
        field: 'userName',
        sort: 'asc'
      },
      {
        label: 'Mobile',
        field: 'mobile',
        sort: 'asc'
      },
      {
        label: 'Email',
        field: 'email',
        sort: 'asc'
      },
      {
        label: 'Added by',
        field: 'added_by',
        sort: 'asc'
      },
      {
        label: 'Added Date, Time',
        field: 'added_date',
        sort: 'asc'
      },
      {
        label: 'Modify by',
        field: 'modify_by',
        sort: 'asc'
      },
      {
        label: 'Modify Date',
        field: 'modify_date',
        sort: 'asc'
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
  },
  systemUser: {
    columns: [
      {
        label: 'Full Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'User Name',
        field: 'userName',
        sort: 'asc'
      },
      {
        label: 'Email',
        field: 'email',
        sort: 'asc'
      },
      {
        label: 'User Role',
        field: 'role',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
    rows: []
  },
  EventOrganizerData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_RECEPTION:
      return {
        ...state,
        // receptionData: action.value
      };
    default:
      return state;
  }
};

export default reducer;
